var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrevIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 35,
    viewBox: "0 0 33 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8133 24.6962V14.6533L11.8047 16.5364",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 1.50643,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8281 24.0687C18.3527 24.4627 19.0046 24.6962 19.7112 24.6962C21.4444 24.6962 22.8496 23.2911 22.8496 21.5578C22.8496 19.8245 21.4444 18.4194 19.7112 18.4194C19.0046 18.4194 18.3527 18.6529 17.8281 19.0468L18.4558 14.6533H22.8496",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 1.50643,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23394 9.04955C1.55491 14.3105 1.24422 23.1489 6.54001 28.7907C11.8358 34.4324 20.7326 34.741 26.4117 29.48C32.0907 24.219 32.4014 15.3806 27.1056 9.73893C24.0934 6.5299 19.916 5.04632 15.8285 5.33171M17.8271 2.09961L14.246 5.49181L17.8271 9.12961",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 2.51072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevIcon);
export default __webpack_public_path__ + "static/media/prev-icon.b3e1abfd7a6b4963aca105656074c726.svg";
export { ForwardRef as ReactComponent };